import { render, staticRenderFns } from "./NewLevel.vue?vue&type=template&id=060f0448&scoped=true"
import script from "./NewLevel.vue?vue&type=script&lang=js"
export * from "./NewLevel.vue?vue&type=script&lang=js"
import style0 from "./NewLevel.vue?vue&type=style&index=0&id=060f0448&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060f0448",
  null
  
)

export default component.exports